import { InfoCircleOutlined } from '@ant-design/icons';
import { type LabelTooltipType } from 'antd/es/form/FormItemLabel';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ApplicationMarket } from '../api/types';

const Container = styled.div`
    padding: 0.5rem;

    & > ul {
        margin-bottom: 0;
        padding-left: 1rem;
    }
`;

const useMarkDownInfoTooltip = (market?: ApplicationMarket): LabelTooltipType => {
    useTranslation('common');

    const [isShowMarketText, text] = useMemo(() => {
        switch (market) {
            case ApplicationMarket.Singapore:
                return [true, 'common:sgMarkDownInfo'];

            case ApplicationMarket.NewZealand:
                return [true, 'common:nzMarkDownInfo'];

            default:
                return [false, ''];
        }
    }, [market]);

    return {
        title: (
            <Container>
                {isShowMarketText && (
                    <Trans
                        components={{
                            br: <br />,
                        }}
                        i18nKey={text}
                    />
                )}
                <Trans
                    components={{
                        br: <br />,
                    }}
                    i18nKey="common:markDownInfo"
                />
            </Container>
        ),
        icon: <InfoCircleOutlined />,
        overlayInnerStyle: { minWidth: '18rem' },
    };
};

export default useMarkDownInfoTooltip;
